module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/escalator.fa586bad.svg";